module.exports = __webpack_public_path__ + "img/front.90cd73cd.png";